module.exports = __webpack_public_path__ + "img/ksh11.236e89cc.png";